<div class="app-header-content">
  <div class="app-header">
    <div class="app-header__top-container sm:p-0">
      <div class="app-header__top-logo">
        <div class="bosch-logo" (click)="goHome('/gb/cn')" style="z-index: 1001;">
        </div>
      </div>
      <div class="app-header__top-link" style="z-index: 1001;">
        <span class="link-box sm:flex mx:flex" (click)="userLogin()">
          <span class="pr-2">{{"HOME_SIGN_IN" | translate}}</span>
          <svg-icon class="header-content-right-icon" [size]="24" [iconName]="'user.png'"></svg-icon>
        </span>
        <div>
          <span class="link-box flex" style="z-index: 1001;">
            <a href="https://www.boschaftermarket.com/xc/en" target="_blank">
              <svg-icon class="header-content-right-icon" style="margin-top: 5px;" [size]="24"
                [iconName]="'choose-country.png'"></svg-icon>
            </a>
          </span>
        </div>
        <div class="app-header__menu-mobile sm:flex mx:hidden sm:px-0">
          <button nz-button *ngIf="!isVisible" (click)="openMenu()" class="menu-button" style="z-index: 1001; background: unset;">
            <i nz-icon nzType="menu"></i>
          </button>
          <button nz-button *ngIf="isVisible" nzType="text" (click)="closeMenu()" style="z-index: 1001;">
            <i nz-icon nzType="close"></i>
          </button>

          <nz-drawer [nzClosable]="false" [nzVisible]="isVisible" nzPlacement="right" nzWidth="100%"
            class="fullscreen-drawer" [nzWrapClassName]="'my-drawer-wrapper'">
            <ng-container *nzDrawerContent>
              <div class="menu-container">
                <div class="menu-header">
                  <button nz-button nzType="text" (click)="goBack()" *ngIf="currentLevel !== 'main'">
                    <i nz-icon nzType="left"></i>
                  </button>
                  <h2>{{ getCurrentMenu().title }}</h2>
                </div>

                <ul nz-menu nzMode="inline" class="ant-menu-custom">
                  <ng-container *ngFor="let item of getCurrentMenu().items">
                    <li nz-menu-item (click)="navigateTo(item)"
                      [class.has-children]="item.children && item.children.length > 0">
                      <span>
                        <i nz-icon [nzType]="item.icon" *ngIf="item.icon"></i>
                        {{ item.title | translate }}
                      </span>
                      <i nz-icon nzType="right" *ngIf="item.children && item.children.length > 0"
                        class="menu-arrow"></i>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </ng-container>
          </nz-drawer>
        </div>
      </div>
    </div>

    <nav class="app-header__menu-title-mobile mx:hidden sm:flex">
      <div class="app-header__company-name">博世智能出行售后（中国）</div>
    </nav>
    <!-- Menu container -->
    <nav class="app-header__menu-container sm:hidden mx:flex">
      <ul nz-menu nzMode="horizontal">
        <ng-container *ngFor="let item of menuItemsDesktop">
          <li *ngIf="item.type === 'item'" nz-menu-item [nzSelected]="item.selectedKey" [nzDisabled]="item.disabled"
            (click)="openPage(item.link, item.pageKey)">
            {{item.title | translate}}
          </li>

          <li *ngIf="item.type === 'submenu'" nz-submenu nzTitle="{{item.title | translate}}" (mouseenter)="onMenuMouseEnter()" (mouseleave)="onMenuMouseLeave()"
            [ngClass]="{'highlighted': item.selectedKey}" (click)="openPage(item.link, item.pageKey)">
            <ul>
              <li *ngFor="let group of item.groups" nz-menu-group nzTitle="{{group.title}}">
                <img [src]="group.icon" [alt]="group.title" style="width: 1.4rem;">
                <ul>
                  <li *ngFor="let subItem of group.items" nz-menu-item
                    [nzSelected]="subItem.selectedKey"
                    (click)="openSubPage(subItem.pageKey); $event.stopPropagation()">
                    <a *ngIf="subItem.pageKey==='frc'">{{subItem.title}}</a>
                    <a [routerLink]="subItem.link" *ngIf="subItem.pageKey!=='frc'">{{subItem.title}}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ng-container>
      </ul>
      <div class="app-header__company-name">博世智能出行售后（中国）</div>
    </nav>
  </div>
</div>